import styled from '@emotion/styled'

import { Column } from 'components/elements/Grid'

const Title = styled(Column)`
	text-align: center;
`

export default Title
